import { Temperature, Length, Mass, Luminosity, QuantityRange as QR } from "../math/math.units";
export class MorganKeenanClass {
    static Parse(str) {
        const a = this.pattern.exec(str);
        if (a) {
            const major = a[0];
            const minor = parseFloat(a[1]);
            const lum = (a.length > 2 ? a[2] : undefined);
            return new MorganKeenanClass(major, minor, lum);
        }
        return undefined;
    }
    constructor(major, minor, luminosity) {
        this._major = major;
        this._minor = minor;
        this._lum = luminosity;
    }
    get major() {
        return this._major;
    }
    get minor() {
        return this._minor;
    }
    get luminosity() {
        return this._lum;
    }
    get fullName() {
        return this._major + this._minor + this._lum ? "(" + this._lum + ")" : "";
    }
}
MorganKeenanClass.pattern = /^(O|B|A|F|G|K|M)([0-9](.[0-9])?)((Ia\+|I|II|III|IV|V|sd|D))?$/;
MorganKeenanClass.LuminosityNames = ["Ia+", "I", "II", "III", "IV", "V", "sd", "D"];
export class SpectralClass {
    static ClassFromTemperature(temperature) {
        const temp = new Temperature(temperature, Temperature.Units.k);
        const c = SpectralClass.HarwardClassification;
        for (let i = 0; i !== c.length; i++) {
            const sc = c[i];
            const min = sc.effectiveTemperature.min;
            const max = sc.effectiveTemperature.max;
            if ((!min || min.value <= temp.value) && (!max || max.value > temp.value)) {
                return sc;
            }
        }
        return undefined;
    }
    constructor(name, effectiveTemperature, VegaRelativeColorLabel, chromacityLabel, mass, radius, luminosity, hydrogenLine, fractionOfStars) {
        this.name = name;
        this.effectiveTemperature = effectiveTemperature;
        this.VegaRelativeColorLabel = VegaRelativeColorLabel;
        this.chromacityLabel = chromacityLabel;
        this.mass = mass;
        this.radius = radius;
        this.luminosity = luminosity;
        this.hydrogenLine = hydrogenLine;
        this.fractionOfStars = fractionOfStars;
    }
}
SpectralClass.O = new SpectralClass("O", new QR(new Temperature(30000, Temperature.Units.k), new Temperature(60000, Temperature.Units.k)), "blue", "blue", new QR(new Mass(16, Mass.Units.Sm)), new QR(new Length(6.6, Length.Units.Sr)), new QR(new Luminosity(30000, Luminosity.Units.Lsun)), "weak", 0.00003);
SpectralClass.B = new SpectralClass("B", new QR(new Temperature(10000, Temperature.Units.k), new Temperature(30000, Temperature.Units.k)), "blue white", "deep blue white", new QR(new Mass(2.1, Mass.Units.Sm), new Mass(16, Mass.Units.Sm)), new QR(new Length(1.8, Length.Units.Sr), new Length(6.6, Length.Units.Sr)), new QR(new Luminosity(25, Luminosity.Units.Lsun), new Luminosity(30000, Luminosity.Units.Lsun)), "weak", 0.13);
SpectralClass.A = new SpectralClass("A", new QR(new Temperature(7500, Temperature.Units.k), new Temperature(10000, Temperature.Units.k)), "white", "blue white", new QR(new Mass(1.4, Mass.Units.Sm), new Mass(2.1, Mass.Units.Sm)), new QR(new Length(1.4, Length.Units.Sr), new Length(1.8, Length.Units.Sr)), new QR(new Luminosity(5, Luminosity.Units.Lsun), new Luminosity(25, Luminosity.Units.Lsun)), "strong", 0.6);
SpectralClass.F = new SpectralClass("F", new QR(new Temperature(6000, Temperature.Units.k), new Temperature(7500, Temperature.Units.k)), "yellow white", "white", new QR(new Mass(1.04, Mass.Units.Sm), new Mass(1.4, Mass.Units.Sm)), new QR(new Length(1.15, Length.Units.Sr), new Length(1.4, Length.Units.Sr)), new QR(new Luminosity(1.5, Luminosity.Units.Lsun), new Luminosity(5, Luminosity.Units.Lsun)), "medium", 3);
SpectralClass.G = new SpectralClass("G", new QR(new Temperature(5200, Temperature.Units.k), new Temperature(6000, Temperature.Units.k)), "yellow", "yello white", new QR(new Mass(0.8, Mass.Units.Sm), new Mass(1.04, Mass.Units.Sm)), new QR(new Length(0.96, Length.Units.Sr), new Length(1.15, Length.Units.Sr)), new QR(new Luminosity(0.6, Luminosity.Units.Lsun), new Luminosity(1.5, Luminosity.Units.Lsun)), "weak", 7.6);
SpectralClass.K = new SpectralClass("K", new QR(new Temperature(3700, Temperature.Units.k), new Temperature(5200, Temperature.Units.k)), "orange	pale", "yello orange", new QR(new Mass(0.45, Mass.Units.Sm), new Mass(0.8, Mass.Units.Sm)), new QR(new Length(0.7, Length.Units.Sr), new Length(0.96, Length.Units.Sr)), new QR(new Luminosity(0.08, Luminosity.Units.Lsun), new Luminosity(0.6, Luminosity.Units.Lsun)), "very weak", 12.1);
SpectralClass.M = new SpectralClass("M", new QR(new Temperature(2400, Temperature.Units.k), new Temperature(3700, Temperature.Units.k)), "red light", "orange red", new QR(new Mass(0.08, Mass.Units.Sm), new Mass(0.45, Mass.Units.Sm)), new QR(new Length(0, Length.Units.Sr), new Length(0.7, Length.Units.Sr)), new QR(new Luminosity(0, Luminosity.Units.Lsun), new Luminosity(0.8, Luminosity.Units.Lsun)), "very weak", 76.45);
SpectralClass.HarwardClassificationIndex = {
    O: SpectralClass.O,
    B: SpectralClass.B,
    A: SpectralClass.A,
    F: SpectralClass.F,
    G: SpectralClass.G,
    K: SpectralClass.K,
    M: SpectralClass.M,
};
SpectralClass.HarwardClassification = [SpectralClass.O, SpectralClass.B, SpectralClass.A, SpectralClass.F, SpectralClass.G, SpectralClass.K, SpectralClass.M];
SpectralClass.TemperatureRange = new QR(new Temperature(2400, Temperature.Units.k), new Temperature(60000, Temperature.Units.k));
//# sourceMappingURL=space.spectralClass.js.map